import IssuerListContainer from '../helpers/IssuerListContainer';

class MolPayEBankingTHElement extends IssuerListContainer {
    public static type = 'molpay_ebanking_TH';
}

export default MolPayEBankingTHElement;
